import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { KvService } from './kv.service';
import { environment } from 'src/environments/environment';
 


export interface PrimoAccessoResponse {
  codiceAutenticazioneApp: string;
  idAzienda: number;
  idAnagrafica: number;
  email: string;
}
export interface PrimaAutenticazioneRequest {
  idAnagrafica: number;
  idAzienda: number;
  email: string;
  password: string;
  repassword: string;
  codiceAutorizzazione: string;
}
export interface PrimaAutenticazioneResponse {
  partitaIVA: string;
  colore1: string;
  colore2: string;
  indirizzo: string;
  logo: string;
  email: string;
  nomeAzienda: string;
  // Campi per telefono (supporta sia 'telefono' che 'telefono1/2')
  telefono?: string;
  telefono1?: string;
  telefono2?: string;
  whatsapp?: string;
  sitoWeb?: string;
}

const KEYS = {
  ONBOARD_DONE: 'onboarding_done',
  ONBOARD_CTX:  'onboarding_ctx',
  COMPANY_INFO: 'company_info'
};

@Injectable({ providedIn: 'root' })
export class OnboardingService {
 
     
  constructor(private http: HttpClient, private kv: KvService) {}

  /** GET con parametri negli HEADER */
  primoAccesso (codiceFiscale: string, codiceAzienda: string): Observable<PrimoAccessoResponse> {
   // codiceFiscale='GMBLNE80A01D969D';
   // codiceAzienda='ASTRA03';
    const baseUrl =  environment.urlapi+'/v1/primoAccesso.do';
    const headers = new HttpHeaders({
      codiceFiscale: (codiceFiscale ?? '').replace(/\s+/g, '').toUpperCase(),
      codiceAzienda: (codiceAzienda ?? '').trim(),
    });
    return this.http.get<PrimoAccessoResponse>(baseUrl, { headers });
  }

  
   async shouldRedirectToLogin(): Promise<boolean> {
    const ctx = await this.getOnboardingContext();
    const done = await this.isOnboardingDone();
    return !!ctx && done;
  }

 

  /** GET con parametri negli HEADER (come richiesto dal backend) */
  primaAutenticazione(req: PrimaAutenticazioneRequest): Observable<PrimaAutenticazioneResponse> {
     const baseUrl =  environment.urlapi+'/v1/primaAutenticazione.do';
    const headers = new HttpHeaders({
      idAnagrafica: req.idAnagrafica,
      idAzienda: req.idAzienda,
      email: (req.email ?? '').trim(),
      password: req.password ?? '',
      repassword: req.repassword ?? '',
      codiceAutorizzazione: (req.codiceAutorizzazione ?? '').trim(),
    });
    return this.http.get<PrimaAutenticazioneResponse>(baseUrl, { headers });
  }
 
  
  async getOnboardingContext(): Promise<PrimoAccessoResponse | null> {
    return await this.kv.get<PrimoAccessoResponse>(KEYS.ONBOARD_CTX);
  }

  
  async getCompanyInfo(): Promise<PrimaAutenticazioneResponse | null> {
    return await this.kv.get<PrimaAutenticazioneResponse>(KEYS.COMPANY_INFO);
  }
 
  async isOnboardingDone(): Promise<boolean> {
    return (await this.kv.get<string>(KEYS.ONBOARD_DONE)) === 'true';
  }


  async saveOnboardingContext(ctx: PrimoAccessoResponse): Promise<void> {
  await this.kv.set(KEYS.ONBOARD_CTX, ctx);
  try { localStorage.setItem(KEYS.ONBOARD_CTX, JSON.stringify(ctx ?? {})); } catch {}
}

async saveCompanyInfo(info: PrimaAutenticazioneResponse): Promise<void> {
  await this.kv.set(KEYS.COMPANY_INFO, info);
  try { localStorage.setItem(KEYS.COMPANY_INFO, JSON.stringify(info ?? {})); } catch {}
}

async setOnboardingDone(done: boolean): Promise<void> {
  const val = done ? 'true' : 'false';
  await this.kv.set(KEYS.ONBOARD_DONE, val);
  try { localStorage.setItem(KEYS.ONBOARD_DONE, val); } catch {}
}


}
